import { FormControl } from '@angular/forms';
import { UserLite } from '@card-software/library';
import { AuditTrail } from '@card-software/nexus-models';
import { LocationPath, LocationType } from '../location';
import { Translation } from '../translation';
import { LotItemType } from './lot-item-search';

export enum LotItemRelocationStatus {
  Draft = 0,
  Completed = 1,
}

export enum LotItemRelocationLineStatus {
  Ready = 0,
  AlreadyHere = 1,
}

export enum LotItemRelocationLineResult {
  Moved = 0,
  Skipped = 1,
}

export enum LotItemRelocationScanResultType {
  Location = 0,
  LotItem = 1,
}

export interface LotItemRelocationLineDto {
  lotItemId: string;
  lotItemNumber: string;
  type?: LotItemType;
  fromLocationCode: string;
  fromLocationPath?: LocationPath;
  lineStatus: LotItemRelocationLineStatus;
  result?: LotItemRelocationLineResult;
}

export interface LotItemRelocationStatusHistoryEntry {
  date: string;
  status: LotItemRelocationStatus;
  user?: UserLite;
}

export interface LotItemRelocationDto extends AuditTrail {
  id: string;
  number: string;
  status: LotItemRelocationStatus;
  warehouseLocationCode: string;
  warehouseCode: string;
  toLocationCode?: string;
  toLocationPath?: LocationPath;
  lines: LotItemRelocationLineDto[];
  statusHistory: LotItemRelocationStatusHistoryEntry[];
}

export type LotItemRelocationScanResultDto =
  | {
      resultType: LotItemRelocationScanResultType.Location;
      code: string;
      name?: Translation;
      locationType?: LocationType;
      path?: LocationPath;
      occupancy?: number;
      relocation?: never;
    }
  | {
      resultType: LotItemRelocationScanResultType.LotItem;
      relocation: LotItemRelocationDto;
      code?: never;
      name?: never;
      locationType?: never;
      path?: never;
      occupancy?: never;
    };

export interface CreateLotItemRelocationCommand {
  warehouseLocationCode: string;
}

export interface LotItemRelocationScanCommand {
  code: string;
}

export interface LotItemRelocationDestinationCommand {
  locationCode: string;
}

export interface LotItemRelocationSearchCommand {
  number?: string;
  username?: string;
  status?: LotItemRelocationStatus;
  locationPaths?: LocationPath[];
}

export interface LotItemRelocationSearchForm {
  number: FormControl<string | null>;
  username: FormControl<string | null>;
  status: FormControl<LotItemRelocationStatus | null>;
  warehouseCode: FormControl<string | null>;
  locationCode: FormControl<string | null>;
}

export interface RelocationWarehouseOption {
  locationCode: string;
  code: string;
  name: string;
  storableLocationCount: number | null;
  lotItemCount: number | null;
}
